// extracted by mini-css-extract-plugin
module.exports = {"TotalPrice":"OrderSummary_TotalPrice__2X5pE"};